/**
 * ProfessocialAccounts ist der Einstiegspunkt die Accountverwaltung für die Admins und Editoren
 */

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { createTheme, CssBaseline, StyledEngineProvider, Theme, ThemeProvider } from '@mui/material'

import * as commonActions from '../store/common/common.actions'

import EditorAccounts from './Editor/EditorAccounts'
import AdminAccounts from './Admin/AdminAccounts'
import { AccountConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

import { getUser } from '../store/common/common.selectors'
import SubsidiaryAccounts from './Subsidiary/SubsidiaryAccounts'

export interface Props {
  accountConfiguration: AccountConfiguration
}

const ProfessocialAccounts: React.FC<Props> = (props) => {
  const dispatch = useDispatch()

  const user = useSelector(getUser)
  const [theme, setTheme] = useState<Theme>(props.accountConfiguration?.theme || createTheme())

  useEffect(() => {
    props.accountConfiguration?.user && dispatch(commonActions.setUser(props.accountConfiguration?.user))
  }, [])

  useEffect(() => {
    props.accountConfiguration.theme && setTheme(props.accountConfiguration.theme)
    props.accountConfiguration.theme && dispatch(commonActions.setTheme(props.accountConfiguration.theme))
  }, [props.accountConfiguration.theme],
  )

  useEffect(() => {
    dispatch(commonActions.setUser(props.accountConfiguration?.user))
  }, [props.accountConfiguration.user],
  )

  useEffect(() => {
    props.accountConfiguration?.language && dispatch(commonActions.setLanguage(props.accountConfiguration?.language))
  }, [props.accountConfiguration.language],
  )

  return (
    <>
      <link rel='stylesheet' href='https://fonts.googleapis.com/icon?family=Material+Icons' />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {user?.role === 'ADMIN' &&
            <AdminAccounts user={user} />}
          {user?.role === 'EDITOR' &&
            <EditorAccounts user={user} />}
          {user?.role === 'SUBSIDIARY' &&
            <SubsidiaryAccounts user={user} />}
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  )
}

export default ProfessocialAccounts
